import React from 'react';

/**
 * 🎭 類型圖標組件
 * 統一管理所有類型的視覺表現
 */
const TypeIcon = ({ type, size = 24, className = '' }) => {
  const typeConfig = {
    merit: {
      emoji: '🙏',
      label: '功德'
    },
    love: {
      emoji: '💖',
      label: '愛情'
    },
    wealth: {
      emoji: '💰',
      label: '財富'
    },
    health: {
      emoji: '🍃',
      label: '健康'
    }
  };

  const config = typeConfig[type];
  if (!config) return null;

  return (
    <span 
      className={className}
      style={{ 
        fontSize: `${size}px`, 
        lineHeight: 1,
        display: 'inline-block'
      }}
      role="img"
      aria-label={config.label}
    >
      {config.emoji}
    </span>
  );
};

export default TypeIcon;